export default __webpack_public_path__ + "static/media/skelly_0006.078bcc13.png";